import React from "react";
import { Box } from "./box";
import { Icon } from "./icon";
import { Check, TriangleAlert } from "lucide-react-native";
import { ParagraphSmall } from "./Typography";

type Props = {
	type: "required" | "approved";
};

const StocklistStatus = (props: Props) => {
	const { type } = props;
	return (
		<Box flexDirection="row" gap={4} alignItems="center">
			{type === "required" && <Icon as={TriangleAlert} color="$warning2xdark" />}
			{type === "approved" && (
				<Box borderRadius="$full" p={4} alignItems="center" justifyContent="center" width={20} height={20} backgroundColor={"$primarylightblue"}>
					<Icon as={Check} color="$basicwhite" />
				</Box>
			)}

			<ParagraphSmall
				sx={{
					fontWeight: "normal",
					lineHeight: 16,
				}}
			>
				{type === "required" && "Requires Approval"}
				{type === "approved" && "Stocklist Approved"}
			</ParagraphSmall>
		</Box>
	);
};

export default StocklistStatus;
